import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeaturedWins from "./components/FeaturedWins";
import WorkExperience from "./components/WorkExperience";
import SkillsTools from "./components/SkillsTools";
import ContactFooter from "./components/ContactFooter";
import ScrollProgressBar from "@/components/feature/ScrollProgressBar";
import BackToTop from "@/components/feature/BackToTop";
import SEO from "@/components/feature/SEO";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Josue Tello",
  "url": siteUrl,
  "jobTitle": "Senior Product & Engineering Leader",
  "description": "Josue Tello is a senior product and engineering leader with a track record of building human-centered products, scaling teams, and driving measurable business impact. Available for VP, Director, and Head of Product roles.",
  "sameAs": [
    "https://linkedin.com/in/josuetello"
  ],
  "knowsAbout": [
    "Product Management",
    "Engineering Leadership",
    "Team Scaling",
    "Human-Centered Design",
    "Business Strategy",
    "Product Strategy",
    "VP of Product",
    "Head of Engineering"
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Josue Tello — Senior Product & Engineering Leader",
  "description": "Josue Tello is a senior product and engineering leader with a track record of building human-centered products, scaling teams, and driving measurable business impact. Available for VP, Director, and Head of Product roles.",
  "url": siteUrl,
  "lastReviewed": "2026-04-08",
  "inLanguage": "en",
  "mainEntity": {
    "@type": "Person",
    "name": "Josue Tello",
    "jobTitle": "Senior Product & Engineering Leader"
  }
};

const profilePageSchema = {
  "@context": "https://schema.org",
  "@type": "ProfilePage",
  "name": "Josue Tello — Senior Product & Engineering Leader",
  "url": siteUrl,
  "dateModified": "2026-04-08",
  "mainEntity": {
    "@type": "Person",
    "name": "Josue Tello",
    "jobTitle": "Senior Product & Engineering Leader",
    "description": "Senior product and engineering leader with a track record of building human-centered products, scaling teams, and driving measurable business impact.",
    "url": siteUrl
  }
};

const combinedSchema = {
  "@context": "https://schema.org",
  "@graph": [personSchema, webPageSchema, profilePageSchema]
};

export default function Home() {
  return (
    <div className="font-dm text-[#FAF8F4]" style={{ backgroundColor: "#140F0A" }}>
      <SEO
        title="Josue Tello — Senior Product & Engineering Leader"
        description="Josue Tello is a senior product and engineering leader with a track record of building human-centered products, scaling teams, and driving measurable business impact. Available for VP, Director, and Head of Product roles."
        keywords="Josue Tello, product leader, engineering leader, VP of Product, Head of Engineering, senior product manager, product strategy, team scaling"
        ogTitle="Josue Tello — Senior Product & Engineering Leader"
        ogDescription="Josue Tello is a senior product and engineering leader with a track record of building human-centered products, scaling teams, and driving measurable business impact. Available for VP, Director, and Head of Product roles."
        ogType="website"
        twitterTitle="Josue Tello — Senior Product & Engineering Leader"
        twitterDescription="Josue Tello is a senior product and engineering leader with a track record of building human-centered products, scaling teams, and driving measurable business impact. Available for VP, Director, and Head of Product roles."
        canonical={siteUrl}
        schema={combinedSchema}
      />
      <ScrollProgressBar />
      <BackToTop />
      <Navbar />
      <main>
        <Hero />
        <FeaturedWins />
        <WorkExperience />
        <SkillsTools />
        <ContactFooter />
      </main>
    </div>
  );
}
